/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Info_Push_TitleInputs */

const en_mobile_info_push_title = /** @type {(inputs: Mobile_Info_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll let you know when your audios are ready`)
};

const es_mobile_info_push_title = /** @type {(inputs: Mobile_Info_Push_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te avisaremos cuando tus audios estén listos`)
};

/**
* | output |
* | --- |
* | "We'll let you know when your audios are ready" |
*
* @param {Mobile_Info_Push_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_info_push_title = /** @type {((inputs?: Mobile_Info_Push_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Info_Push_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_info_push_title(inputs)
	return en_mobile_info_push_title(inputs)
});